import React from 'react';
import PropTypes from 'prop-types';
import SimpleMarkdown from 'simple-markdown';

/**
 * @example
 * [indent]
 * Hello world.
 *
 * I feel like a pickle.
 * [/indent]
 */

const regex = /^\[indent]((?:[\w\W](?!\[\/indent]))+[\w\W])\[\/indent]/;

const indentedRule = {
  order: SimpleMarkdown.defaultRules.paragraph.order - 0.5,
  match: (source) => regex.exec(source),
  parse: (capture, recurseParse, state) => {
    const [, content] = capture;
    return {
      content: recurseParse(`${content}\n`, state)
    };
  },
  react({content}, output, {key}) {
    return (
      <div key={key} className='ml-x4'>
        {output(content)}
      </div>
    );
  },
  /**
   * `htmlOutput` feeds notification emails, which can't resolve the `ml-x4`
   * utility class, so the indent is inlined at that token's value (`--spacing-x4`).
   */
  html({content}, output) {
    return `<div style="margin-left: 32px">${output(content)}</div>`;
  }
};

indentedRule.react.propTypes = {
  content: PropTypes.node
};

export default indentedRule;
